<template>
  <div class="inventory-container">
    <div class="inventory-header-top row p-1">
      <div class="col-2 p-1 inventory-tab" :class="{'active': activeTab.combat}" @click="setActive('combat')">
        <div class="tab-item p-1">
          <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/icons/combat.png" title="Combat"
               alt="Combat">
        </div>
      </div>
      <div class="col-2 p-1 inventory-tab" :class="{'active': activeTab.stats}" @click="setActive('stats')">
        <div class="tab-item p-1">
          <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/icons/stats.png" title="Stats"
               alt="Stats">
        </div>
      </div>
      <div class="col-2 p-1 inventory-tab" :class="{'active': activeTab.equipment}"
           @click="setActive('equipment')">
        <div class="tab-item p-1">
          <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/icons/equipment.png"
               title="Equipment" alt="Equipment">
        </div>
      </div>
      <div class="col-2 p-1 inventory-tab" :class="{'active': activeTab.prayer}" @click="setActive('prayer')">
        <div class="tab-item p-1">
          <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/icons/prayer.png" title="Prayer"
               alt="Prayer">
        </div>
      </div>
      <div class="col-2 p-1 inventory-tab" :class="{'active': activeTab.settings}" @click="setActive('settings')">
        <div class="tab-item p-1">
          <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/icons/options.png"
               title="Settings" alt="Settings">
        </div>
      </div>
      <div class="col-2 p-1 inventory-tab" :class="{'active': activeTab.sharing}" @click="setActive('sharing')">
        <div class="tab-item p-1">
          <img loading="lazy" sizes="100%, 100%" class="img-fluid" src="/static/images/icons/equipment_share.png"
               title="Sharing" alt="Sharing">
        </div>
      </div>
    </div>


    <div class="inventory-body row pt-3">
      <div class="tab-content col-12" id="inventoryContent">
        <div class="tab-pane fade" :class="{'show active' : activeTab.combat}" id="stance" role="tabpanel"
             aria-labelledby="stance-tab">

          <StanceTab @stanceSelected="setStance" @spellbookSwap="setSpellbook" @spellSelected="setSpell"
                     :weapon="setup.equipment.weapon"
                     :active-spell="setup.activeSpell"
                     :active-stance="setup.activeStance" :active-spellbook="setup.activeSpellbook"></StanceTab>

        </div>

        <div class="tab-pane fade" :class="{'show active' : activeTab.stats}" id="stats" role="tabpanel"
             aria-labelledby="stats-tab">
          <PlayerStats :boosts="boosts" :stats="player" :active-potions="setup.potions"
                       @potionUpdate="setPotions"></PlayerStats>
        </div>


        <div class="tab-pane fade" :class="{'show active' : activeTab.equipment}" id="equipment" role="tabpanel"
             aria-labelledby="equipment-tab">
          <EquipmentTab @equipmentChanged="setEquipmentItem" :equipment="setup.equipment"></EquipmentTab>
        </div>

        <div class="tab-pane fade" :class="{'show active' : activeTab.prayer}" id="prayer" role="tabpanel"
             aria-labelledby="prayer-tab">
          <PrayerTab :active-prayers="setup.prayers" @stateChanged="setPrayerState"></PrayerTab>
        </div>

        <div class="tab-pane fade" :class="{'show active' : activeTab.items}" id="items" role="tabpanel"
             aria-labelledby="items-tab">
          <small><i>Coming Soon :)</i></small>
        </div>

        <div class="tab-pane fade" :class="{'show active' : activeTab.settings}" id="settings" role="tabpanel"
             aria-labelledby="settings-tab">
          <SettingsTab @update="setSetting" :settings="setup.settings"></SettingsTab>
        </div>

        <div class="tab-pane fade" :class="{'show active' : activeTab.sharing}" id="sharing" role="tabpanel"
             aria-labelledby="sharing-tab">
          <SharingTab :shared="setupShared" @shared="setupShared=true" @load="loadPreset" @clone="clone"
                      :setup="setup"></SharingTab>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StanceSelector from "./gear-selector/StanceSelector";
  import EquipmentBonus from "./gear-selector/EquipmentBonus";
  import PlayerStats from "./PlayerStats";
  import StanceTab from "./tabs/StanceTab";
  import GearPreview from "./gear-selector/GearPreview";
  import EquipmentTab from "./tabs/EquipmentTab";
  import PotionsTab from "./tabs/PotionsTab";
  import PrayerTab from "./tabs/PrayerTab";
  import SettingsTab from "./tabs/SettingsTab";
  import SharingTab from "./tabs/SharingTab";

  export default {
    name: "InventoryContainer",
    components: {
      SharingTab,
      SettingsTab,
      PrayerTab,
      PotionsTab, EquipmentTab, GearPreview, StanceTab, PlayerStats, EquipmentBonus, StanceSelector
    },
    props: {
      setup: {
        type: Object,
      },
      player: {
        type: Object,
      },
      boosts: {
        type: Object,
      }
    },
    data() {
      return {
        setupShared: false,
        activeTab: {
          combat: false,
          stats: false,
          equipment: true,
          items: false,
          prayer: false,
          potions: false,
          settings: false,
          sharing: false,
        }
      }
    },
    methods: {
      setActive: function (tab) {
        this.activeTab = {
          combat: false,
          stats: false,
          equipment: false,
          items: false,
          prayer: false,
          potions: false,
          settings: false,
          sharing: false,
        };

        this.activeTab[tab] = true;
      },


      setEquipmentItem: function (slot, item) {
        // this.setup.equipment[slot] = item;
        this.$set(this.setup.equipment, slot, item);

        if (slot === 'weapon') {
          if (item.is_two_handed) {
            let none = require('@/assets/data/equipment/none.json');
            none.slot = this.itemSlot;
            this.$set(this.setup.equipment, 'shield', none)
          }

          this.setStance(item.weapon.stances[0])
        }

        if (slot === 'shield' && this.setup.equipment.weapon.hasOwnProperty('is_two_handed')) {
          let none = require('@/assets/data/equipment/none.json');
          none.slot = this.itemSlot;
          this.$set(this.setup.equipment, 'weapon', none)
        }

        this.setupShared = false;
        this.$emit('equipmentChanged', this.setup.equipment)
      },

      setPotions: function (potions) {
        this.setup.potions = potions;
        this.update()
      },

      setPrayerState: function (prayer, state) {
        this.update();
      },

      setStance: function (stance) {
        this.setupShared = false;
        this.$emit('stanceChange', stance);
      },

      setSpell: function (spell) {
        this.setupShared = false;
        this.$emit('spellChange', spell);
      },

      setSpellbook: function (spellbook) {
        this.$emit('spellbookChange', spellbook);
      },

      setSetting: function (setting) {
        this.setupShared = false;
        this.$emit('settingsChange', setting)
      },

      loadPreset: function (set) {
        this.setupShared = false;
        this.$emit('loadPreset', set);
        this.setActive('equipment');
      },

      clone: function () {
        this.$emit('setClone');
      },

      update: function () {
        this.setupShared = false;
        this.$emit('update')
      }
    }
  }
</script>

<style scoped>
  .inventory-body {
    min-height: 300px;
  }

  .inventory-body {
    /*background: #3F3529;*/
    /*background: url("/static/images/icons/placeholders/inventory.png");*/
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .tab-item {
    /*border-radius: 3px;*/
    /*border-left: 1px solid #dbcba3;*/
    /*border-top: 1px solid #dbcba3;*/
    /*border-bottom: 1px solid #dbcba3;*/
    /*background: grey;*/

    border: 1px solid black;
    border-radius: 8px;
    box-shadow: 0 0 0 0.1rem rgba(0, 0, 0, 0.2);

    cursor: pointer;
  }

  /*.inventory-tab:last-child {*/
  /*  border-right: 1px solid #dbcba3;*/
  /*}*/

  .tab-item > img {
    min-height: 30px;
  }

  .inventory-tab-icon {
    height: auto;
    width: 36px;
    /*height: 38px;*/
  }

  .inventory-tab.active > .tab-item {
    background: #821F1C;
  }

  .offset-05 {
    margin-left: 4.1666665%;
  }

  .offset-15 {
    margin-left: 12.4999995%;
  }

  .col-15 {
    -ms-flex: 0 0 12.4999995%;
    -webkit-box-flex: 0;
    flex: 0 0 12.4999995%;
    max-width: 12.4999995%;
  }

  .col-15 {
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/InventoryContainer.vue